module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAA+BAMAAACPagldAAAAG1BMVEVHcEyGav+Gav+Gaf+Gav+Gaf+Gav+Gav+Gav+6F4StAAAACHRSTlMA478kaEeihdDWKyIAAAEGSURBVFjD7Zg9C8IwEIajsegoHSSjXapjoLh3Kf6AtuAoUqizVHE04Ed/tqmCQtVq27zgcO8PuCd3l+UexvDpOTkoI7+ob4kcFiU1YJEDc9IAgQQovYEcGp91sYAx62ABQzbAAg4EIAABCEAAAhCAAAQgAAEI8ADALxz4jdZHX5kcC9Cn/h5Z/6gvfegSloUNWePqX246x5qi6p/lXRjxjUCUV8nTSfFoZ9hKqTSQJfFlzVemGrGT8L1cM9GIcrey0uB5bRr5+PRS4iaNKDeQNVQkj2o1YmdhA985+21adlrr6S+QymmpSZviX/6WHrpnzA6XIXosnnEFzfVOHKFsN4sl+59cAdxPno0Uz5scAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/lesson-4.png
// module id = 613
// module chunks = 1